import PropTypes from 'prop-types';
import React from 'react';

import { ContentSubHeader, PageHeaderBlock } from '../content-image';
import { convertToSlug } from '../../utils/convert-to-slug';
import { decals } from '../decal/constants';
import { navigation } from '../../constants';

const RestaurantPageHeader = ({ state, name, backgroundImage }) => {
  const breadcrumbs = {
    title: name,
    ancestors: [
      {
        title: 'Restaurants',
        url: navigation.RESTAURANTS,
      },
      {
        title: state,
        url: `${navigation.RESTAURANTS}/${convertToSlug(state)}`,
      },
    ],
  };

  return (
    <>
      <PageHeaderBlock
        backgroundImage={[backgroundImage]}
        heading={name}
        hasHeadingHighlight
        py="0"
        leftDecal={decals['peri-products'].left}
        leftDecalStyle={{ top: { xs: '50%', md: 3 }, transform: { xs: `translateY(-50%)`, md: `translateY(0%)` } }}
        rightDecal={decals['peri-products'].right}
        rightDecalStyle={{ top: { xs: '50%', md: 3 }, transform: { xs: `translateY(-50%)`, md: `translateY(0%)` } }}
      />
      <ContentSubHeader breadcrumbs={breadcrumbs} />
    </>
  );
};

RestaurantPageHeader.propTypes = {
  name: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  backgroundImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
};

RestaurantPageHeader.defaultProps = {
  backgroundImage: undefined,
};

export { RestaurantPageHeader };
